module.exports = __webpack_public_path__ + "static/media/052019-Summer-GIFs_2-min.03193b8a.gif";